module.exports = __webpack_public_path__ + "img/Trash.d4d22ffa.svg";